import { up, down } from "slide-element";

export default class ResponsiveHelper {
    public static device = {
        isSmartphone: window.matchMedia("screen and (max-width:599px)"),
        isSmalltablet: window.matchMedia("screen and (min-width:600px) and (max-width:749px)"),
        isTablet: window.matchMedia("screen and (min-width:750px) and (max-width:1110px)")
    };

    public static onResize() {
        let self = this;
        this.setWrapMenu();

        window.addEventListener("resize", function (event) {
            self.setWrapMenu();
        }, true);
    }

    private static setWrapMenu() {
        if (this.device.isTablet.matches || this.device.isSmalltablet.matches || this.device.isSmartphone.matches) {
            document.querySelector(".wrap-tap").addEventListener("click", event => {
                document.querySelectorAll(".app-header").forEach(x => {
                    x.classList.remove("show");
                });
                document.querySelectorAll(".app-header").forEach(x => {
                    x.classList.remove("submenu");
                });
                document.querySelectorAll(".exp-button, .accordion").forEach(x => {
                    x.classList.remove("active");
                });
                document.querySelectorAll(".wrap-tap").forEach(x => {
                    x.classList.remove("show");
                });
                document.querySelectorAll(".exp-nav").forEach(x => {
                    x.classList.remove("show");
                });
                document.querySelectorAll(".section-wrap").forEach(x => {
                    x.classList.remove("show");
                });
                document.querySelectorAll(".sections-items").forEach(x => {
                    x.classList.remove("selected");
                });
            });

            document.querySelector(".wrapmenu-button").addEventListener("click", event => {
                document.querySelectorAll(".app-header").forEach(x => {
                    x.classList.add("show");
                });
                document.querySelectorAll(".wrap-tap").forEach(x => {
                    x.classList.add("show");
                });
            });

            document.querySelectorAll(".exp-button[data-menu='wrap']").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");
                    if (section != "lang") {
                        document.querySelector(".exp-nav[data-type=" + section + "]").classList.add("show");
                    }
                    document.querySelector(".exp-button[data-type=" + section + "]").classList.add("active");
                    document.querySelectorAll(".app-header").forEach(x => {
                        x.classList.add("submenu");
                    });
                    document.querySelectorAll(".wrap-tap").forEach(x => {
                        x.classList.add("show");
                    });

                    if (section === "lang") {
                        document.dispatchEvent(new Event('LanguageSelection'));
                    }
                });
            });

            document.querySelectorAll(".button-exp[data-account]").forEach(element => {
                element.addEventListener("click", event => {
                    document.querySelector(".app-header").classList.add("submenu");
                });
            });

            document.querySelectorAll(".wrap-back.layer-01").forEach(element => {
                element.addEventListener("click", event => {
                    document.querySelectorAll(".exp-nav").forEach(x => {
                        x.classList.remove("show");
                    });
                    document.querySelectorAll(".exp").forEach(x => {
                        x.classList.remove("show");
                    });
                    document.querySelectorAll(".exp-button, .accordion").forEach(x => {
                        x.classList.remove("active");
                    });
                    document.querySelectorAll(".app-header").forEach(x => {
                        x.classList.remove("submenu");
                    });
                });
            });

            document.querySelectorAll(".section-wrap").forEach(x => {
                x.classList.remove("show");
            });
            document.querySelectorAll(".sections-items .item").forEach(x => {
                x.classList.remove("active");
            });

            document.querySelectorAll(".sections-items .item").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");

                    document.querySelectorAll(".section-wrap[data-type=" + section + "]").forEach(x => {
                        x.classList.add("show");
                    });
                    document.querySelectorAll(".sections-items").forEach(x => {
                        x.classList.add("selected");
                    });

                });
            });

            document.querySelectorAll(".wrap-back.layer-02").forEach(element => {
                element.addEventListener("click", event => {
                    document.querySelectorAll(".section-wrap").forEach(x => {
                        x.classList.remove("show");
                    });
                    document.querySelectorAll(".sections-items").forEach(x => {
                        x.classList.remove("selected");
                    });
                });
            });

            document.querySelectorAll(".accordion").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");
                    const select = document.querySelector(".title.accordion[data-type=" + section + "]");

                    if (select != null && select.classList.contains("active")) {
                        up(document.querySelector(".accordion-nav[data-type=" + section + "]"));
                        document.querySelectorAll(".accordion").forEach(x => {
                            x.classList.remove("active");
                        });
                    } else {
                        document.querySelectorAll(".accordion-nav").forEach(x => {
                            if (x.getAttribute("data-type") != section) {
                                up(<HTMLElement>x);
                            } else {
                                down(<HTMLElement>x);
                            }
                        });
                        document.querySelectorAll(".accordion").forEach(x => { x.classList.remove("active"); });
                        document.querySelector(".accordion[data-type=" + section + "]").classList.add("active");
                    }
                });
            });
        } else {
            document.querySelector(".wrap-tap")?.classList.remove("show");
            document.querySelector(".app-header")?.classList.remove("show");
            document.querySelector(".app-header")?.classList.remove("submenu");
            document.querySelector(".section-wrap[data-type='replacement']")?.classList.add("show");
            document.querySelector(".sections-items .item[data-type='replacement']")?.classList.add("active");
            document.querySelector(".section-wrap[data-type='aftermarket']")?.classList.add("show");
            document.querySelector(".sections-items .item[data-type='aftermarket']")?.classList.add("active");

            document.querySelectorAll(".exp-button").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");
                    const select = document.querySelector(".exp-button[data-type=" + section + "]");

                    if (select != null && select.classList.contains("active") && section != "lang") {
                        up(document.querySelector(".exp-nav[data-type=" + section + "]"));
                        document.querySelector(".exp-button[data-type=" + section + "]").classList.remove("active");
                    } else {
                        document.querySelectorAll(".exp-nav").forEach(x => {
                            if (x.getAttribute("data-type") != section) {
                                up(<HTMLElement>x);
                            } else {
                                down(<HTMLElement>x);
                            }
                        });
                        document.querySelectorAll(".exp-button").forEach(x => { x.classList.remove("active"); });
                        document.querySelector(".exp-button[data-type=" + section + "]").classList.add("active");
                    }

                    if (section === "lang") {
                        document.dispatchEvent(new Event('LanguageSelection'));
                    }
                });
            });

            document.querySelectorAll(".exp-nav[data-products] .sections-items .item").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");
                    document.querySelectorAll(".exp-nav[data-products] .section-wrap").forEach(x => { x.classList.remove("show") });
                    document.querySelector(".exp-nav[data-products] .section-wrap[data-type=" + section + "]").classList.add("show");
                    document.querySelectorAll(".exp-nav[data-products] .sections-items .item").forEach(x => { x.classList.remove("active") });
                    document.querySelector(".exp-nav[data-products] .sections-items .item[data-type=" + section + "]").classList.add("active");
                });
            });

            document.querySelectorAll(".exp-nav[data-bike] .sections-items .item").forEach(element => {
                element.addEventListener("click", event => {
                    var section = element.getAttribute("data-type");
                    document.querySelectorAll(".exp-nav[data-bike] .section-wrap").forEach(x => { x.classList.remove("show") });
                    document.querySelector(".exp-nav[data-bike] .section-wrap[data-type=" + section + "]").classList.add("show");
                    document.querySelectorAll(".exp-nav[data-bike] .sections-items .item").forEach(x => { x.classList.remove("active") });
                    document.querySelector(".exp-nav[data-bike] .sections-items .item[data-type=" + section + "]").classList.add("active");
                });
            });
        }
    }
}